import React, { useCallback, useEffect, useState } from 'react'
import { maApiFetch } from '../../api'
import { useEodDrawer } from '../../providers/EodDrawerContext'
import { FormProvider, formDataTransform, usePersistReducer, LOCAL_STORAGE_KEY } from './formUtils'
import { notifyError, notifySuccess } from '../../utils/helpers'
import FormWizard from './FormWizard'
import isEmpty from 'lodash/isEmpty'

export default function AnalystInvestigation() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [state, dispatch] = usePersistReducer()
  const { dispatch: { onClose, setRequestType }, state: drawerState, mode, maApiHost, authenticatedFetch } = useEodDrawer()

  useEffect(() => {
    if (!isEmpty(drawerState.withFileHash)) {
      dispatch({ type: 'updateAttachments', payload: [drawerState.withFileHash] })
    }
  }, [drawerState.withFileHash, dispatch])

  const handleSaveToLocalStorage = useCallback(() => {
    const canBeSavedToLocalStorage = state.save_data.value
    if (canBeSavedToLocalStorage) {
      const stateToSave = {}
      for (const key in state) {
        if (state[key].can_save || key === 'availability_days' || key === 'availability_hours' || key === 'availability_timezone') {
          stateToSave[key] = state[key]
        }
      }
      try {
        // only save items in `newState` that have `can_save` set to `true`
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(stateToSave))
      } catch {
        // ignore for users in incognito mode
      }
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY)
    }
  }, [state])

  const onSubmit = React.useCallback(() => {
    setIsSubmitting(true)
    handleSaveToLocalStorage()
    const formBody = formDataTransform(state)
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formBody),
    }
    maApiFetch('/eod/cases', options, maApiHost, authenticatedFetch)
      .then(response => {
        if (response.errors) {
          throw new Error(response.errors)
        } else {
          notifySuccess('Analyst Investigation request', `Your request #${response.case_number} has been submitted.`)
          onClose()
        }
      })
      .catch(error => {
        notifyError('Error', 'We are unable to complete your request. Please try again.')
        setIsSubmitting(false)
        throw new Error(error)
      })
  }, [state, onClose, handleSaveToLocalStorage, maApiHost, authenticatedFetch])

  return (
    <FormProvider mode={mode} dispatch={dispatch} state={state} onSubmit={onSubmit} onClose={onClose} isSubmitting={isSubmitting} setRequestType={setRequestType}>
      <FormWizard />
    </FormProvider>
  )
}
